import { render, staticRenderFns } from "./EnacAtplDashboardItemLearnerGoals.vue?vue&type=template&id=2ebacf11"
import script from "./EnacAtplDashboardItemLearnerGoals.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardItemLearnerGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports